import { useContext } from 'react';
import { useTheme } from '@mui/material';

import { assertIsDefined } from '@/helpers/assertions';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { BreakpointsContext } from '@/providers/BreakpointsProvider/BreakpointsContextProvider';

export const useBreakpointsManager = () => {
  const { breakPoints } = useTheme();

  const isDesktop = useMediaQuery(breakPoints.desktopSmallUp);

  return { isDesktop };
};

export const useBreakpointsCtx = () => {
  const { isDesktop } = useContext(BreakpointsContext);

  assertIsDefined(isDesktop, '"IBreakpointsContext.isDesktop has to be defined!"');

  return {
    isDesktop,
  };
};
